// extracted by mini-css-extract-plugin
export var closeButton = "_17-1";
export var container = "_17-0";
export var fullModalImage = "_17-2";